jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
	loginPage: {
		init: function init() {
			jPar.wdk.forms.init();
			this.validate.init();
			this.socialSignOn.init();
			this.stayLoggedInInfo();
			this.accessTokenSubmit();

			try {
				this.loginDelay();
			} catch (e) {
				jPar.util.log.error(e.stack, 'jPar.loginAndRegistration.loginPage.init: low prio failed');
			}

			if ($j('#verificationCodeFailedModal').length > 0) {
				jPar.wdk.modalbox.show({ modalboxId: 'verificationCodeFailedModal' });
			}

			// kann im iframe im messenger geladen werden bei abgelaufener Session
			parent.postMessage({ domLoaded: 'loginPage' }, window.location.origin);
		},

		emailPermissionRetries: 0,

		validate: {
			init: function init() {
				try {
					const _this = this;

					$j('#loginFormSubmit').on('click', function (event) {
						_this.submitForm(event);
					});

					$j('#loginFormEmail').on('change', function (event) {
						if (jPar.util.validate.isNotTabOrShiftKey(event.keyCode) && $j(this).val() !== '') {
							_this.validateEmail();
						}
					});

					$j('#loginFormPasswort').on('keyup change', function (event) {
						if (jPar.util.validate.isNotTabOrShiftKey(event.keyCode)) {
							_this.validatePassword();
						}
					});
				} catch (e) {
					jPar.util.log.error(e.stack, 'jPar.loginAndRegistration.loginPage.validate.init');
				}
			},

			validateEmail: function validateEmail() {
				const $elem = $j('#emailRow');
				const $errorElement = $elem.find('#loginFormEmailError');
				const $emailElement = $elem.find('#loginFormEmail');
				const isEmailEmpty = jPar.util.validate.textfieldIsEmpty($emailElement);
				const isNotEmail = jPar.util.validate.isEmailAddress($emailElement) === false;

				if (isNotEmail || isEmailEmpty) {
					jPar.wdk.forms.showError($errorElement);
				} else {
					jPar.wdk.forms.hideError($errorElement);
				}
			},

			validatePassword: function validatePassword() {
				const $elem = $j('#passwordRow');
				const $errorElement = $elem.find('#loginFormPasswordError');
				if (jPar.util.validate.textfieldIsEmpty($elem.find('#loginFormPasswort'))) {
					jPar.wdk.forms.showError($errorElement);
				} else {
					jPar.wdk.forms.hideError($errorElement);
				}
			},

			validateCompleteForm: function validateCompleteForm() {
				jPar.wdk.forms.hideError($j('#loginError2'));

				this.validateEmail();
				this.validatePassword();
			},

			hasValidationErrors: function hasValidationErrors() {
				return jPar.wdk.forms.hasVisibleErrors($j('#loginForm'));
			},

			submitForm: function submitForm(event) {
				this.validateCompleteForm();

				if (this.hasValidationErrors()) {
					event.preventDefault();
				} else {
					jPar.loginAndRegistration.util.showLoadingAnimation();
				}
			},
		},

		loginDelay: function loginDelay() {
			const loginDelay = $j('#loadingText').data('logindelay');

			if (loginDelay !== undefined) {
				window.setTimeout(function () {
					jPar.loginAndRegistration.util.hideLoadingAnimation();
				}, loginDelay);
			}
		},

		stayLoggedInInfo: function () {
			$j('.js-showStayLoggedInModal').on('click', function (event) {
				event.preventDefault();

				jPar.wdk.modalbox.show({
					modalboxId: 'stayLoggedInModal',
				});
			});
		},

		accessTokenSubmit: function () {
			if (document.querySelector('body.accessTokenPage') !== null) {
				document.getElementById('loginForm').submit();
			}
		},
	},
});
